export const FIRST_NAME_KEY = 'firstName';
export const LAST_NAME_KEY = 'lastName';
export const PHONE_KEY = 'phone';
export const EMAIL_KEY = 'email';
export const SALUTATION_KEY = 'salutation';
export const DISCOUNT_KEY = 'discount';
export const PERSONAL_DETAILS_FIRST_NAME_KEY = 'personalDetailsFirstName';
export const PERSONAL_DETAILS_LAST_NAME_KEY = 'personalDetailsLastName';
export const PERSONAL_DETAILS_PHONE_KEY = 'personalDetailsPhone';
export const PERSONAL_DETAILS_EMAIL_KEY = 'personalDetailsEmail';
export const FIELD_SEPARATOR = '{fieldName}';
export const SESSION_STORAGE_GUEST_KEY = 'guestEmail';
